var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"link-list__items--upercase"},_vm._l((_vm.links),function(link){return _c('li',{key:link.label,staticClass:"link-list__item"},[_c(_vm.component(link),_vm._b({tag:"component",class:{'external-link': link.type === 'external' }},'component',link,false))],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-484c464a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/layout/footer/components/AboutSuperbet.vue
// module id = 1853
// module chunks = 0